import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EXTERNAL_POD_GUIDE } from "@/settings/constant";
import { Button, Icon, Typography } from "@bookips/sds";
import Link from "next/link";
const Header = ()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full sm:w-[600px] mx-auto pt-10 flex justify-between items-center px-4 sm:px-0 pb-5",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h4",
                className: "text-strong",
                children: "제본 신청"
            }),
            /*#__PURE__*/ _jsx(Link, {
                href: EXTERNAL_POD_GUIDE,
                target: "_blank",
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "stroke",
                    color: "secondary",
                    leftElement: /*#__PURE__*/ _jsx(Icon.Info_2px, {
                        className: "size-4.5 text-secondary"
                    }),
                    children: "제본 서비스 안내"
                })
            })
        ]
    });
};
export default Header;
